import React from 'react';
import { createRoot } from 'react-dom/client';
import CleaningEstimator from './EstimateCalculator';

const container = document.getElementById('maidlink-estimator-root');
const root = createRoot(container);  // React 18+
root.render(<CleaningEstimator />);
